
import { Component, Prop } from 'vue-property-decorator'
import Mixin from '../helpers/mixin'

@Component({
  template: `
  <div class='subcategories-overview category-nav'>
    <a
      v-for="item in itemsToShow" class='category' :href='item.url'>
      <template v-if="imageUrl(item) && imageUrl(item) !== ''">
        <img :src='imageUrl(item) + imageQuery' :alt='title(item)' />
      </template>
      <template v-else-if="defaultImage && defaultImage !== ''">
        <img :src='defaultImage + imageQuery' :alt='title(item)'>
      </template>
      <template v-else>
        <div class='image'></div>
      </template>
      <div class='bottom flex flex-align-center flex-justify-center'>
        <h3 class='title gray3--text text-center'>{{ title(item) }}</h3>
      </div>
      <i class="icons8-chevron-down-2 flex-align-center category__icon hidden-desktop hidden-tablet"></i>
    </a>
  </div>
  `
})
export default class SubcategoriesItems extends Mixin {
  @Prop() items: any
  @Prop() defaultImage: string

  itemsToShow = []

  imageQuery = '?width=250&height=250&mode=Min&format=webp'

  created() {
    this.itemsToShow = this.items.toSorted((a: any, b: any) => b.priority - a.priority)
  }

  title(item: any): string {
    if (item.heroTitle && item.heroTitle != '') {
      return item.heroTitle
    } else if (item.title !== '') {
      return item.title
    }
    return ''
  }

  imageUrl(item: any): string {
    if (item.imageUrl && item.imageUrl != '') {
      return item.imageUrl
    }
    return ''
  }
}
